<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.meter-operation' | translate"
          [tooltip]="'tooltips.technical-data.meter-operation' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="section-wrapper margin-align" [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="top-bottom-margin section-column">
      <div class="section-field">
        <p-radioButton
          name="meter_operation"
          value="localOperator"
          [(ngModel)]="technicalData.meter_operation"
          #meter_operation="ngModel"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label class="ml-2">
          {{ 'grid-comp.mo-local-operator' | translate }}
        </label>
      </div>
      <div class="section-field">
        <p-radioButton
          name="meter_operation"
          value="externalOperator"
          [(ngModel)]="technicalData.meter_operation"
          #meter_operation="ngModel"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label class="ml-2">
          {{ 'grid-comp.mo-done-by' | translate }}
        </label>
        <input
          class="form-control ml-3"
          *ngIf="technicalData.meter_operation === 'externalOperator'"
          type="text"
          pInputText
          [(ngModel)]="technicalData.meter_operator"
          placeholder="{{ 'grid-comp.enter-operator' | translate }}"
          name="meter_operator"
          #meter_operator="ngModel"
          required
          [disabled]="isSectionDisabled" />
      </div>
    </div>
  </div>
</div>
